"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownTitle = exports.getConfigPerColumn = void 0;
// packages
const react_1 = __importDefault(require("react"));
// styles
const DropdownTitle_styles_1 = require("./DropdownTitle.styles");
const Dropdown_styles_1 = require("./Dropdown.styles");
const getConfigPerColumn = (index, props) => {
    const { config, title } = props;
    console.log(index);
    switch (index) {
        case 1:
            return {
                label: title.firstColumn,
                width: (config === null || config === void 0 ? void 0 : config.firstColumnWidth) || Dropdown_styles_1.ITEM_LEFT_WIDTH,
            };
        case 2:
            return {
                label: title.secondColumn,
                width: (config === null || config === void 0 ? void 0 : config.secondColumnWidth) || Dropdown_styles_1.ITEM_CENTER_WIDTH,
            };
        case 3:
            return {
                label: title.thirdColumn,
                width: (config === null || config === void 0 ? void 0 : config.thirdColumnWidth) || Dropdown_styles_1.ITEM_RIGHT_WIDTH,
            };
        case 4:
            return {
                label: title.forthColumn,
                width: (config === null || config === void 0 ? void 0 : config.fourthColumnWidth) || Dropdown_styles_1.ITEM_RIGHT_WIDTH,
            };
        default:
            return {
                label: title.firstColumn,
                width: (config === null || config === void 0 ? void 0 : config.firstColumnWidth) || Dropdown_styles_1.ITEM_LEFT_WIDTH,
            };
    }
};
exports.getConfigPerColumn = getConfigPerColumn;
const StyledDropdownTitle = (props) => {
    var _a, _b;
    const numberOfColumns = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.numberOfColumns) !== null && _b !== void 0 ? _b : 3;
    const columnsToShow = [...Array(numberOfColumns).keys()].map((_, index) => {
        const config = (0, exports.getConfigPerColumn)(index + 1, props);
        return (react_1.default.createElement(DropdownTitle_styles_1.StyledTitleLabel, { key: config.label, height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: config.width, paddingLeft: Dropdown_styles_1.ITEM_PADDING_LEFT },
            react_1.default.createElement(DropdownTitle_styles_1.StyledTitleText, { height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: '100%' }, config.label)));
    });
    return (react_1.default.createElement(DropdownTitle_styles_1.StyledTitleContainer, null,
        react_1.default.createElement(DropdownTitle_styles_1.StyledTitleElement, null, columnsToShow.map((i) => i))));
};
exports.StyledDropdownTitle = StyledDropdownTitle;
exports.default = exports.StyledDropdownTitle;
//# sourceMappingURL=DropdownTitle.js.map